"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(str) {
    const bytes = [];
    for (let i = 0; i < str.length; i = i + 2) {
        bytes.push(parseInt(str.slice(i, i + 2), 16));
    }
    return Buffer.from(bytes);
}
exports.default = default_1;
